import {PureComponent} from 'react'

import OffersExamples from './OffersExamples.jsx'

import './OffersExamples.scss'

export default class OffersExamplesFinance extends PureComponent {
  render() {
    const title = "Finance : nos exemples de missions"
    const description = "Retrouvez les différents types de missions en Finance déjà postés sur notre plateforme : management de transition, interim management, groupe international, ETI, etc."

    return <OffersExamples
      helmet={{title, description}}
      universeCode="finance"
      title="Les missions Finance que vous auriez pu recevoir :"
    />
  }
}
